import React, { memo } from "react";
import * as PropTypes from "prop-types";
import { methods } from "../../../constants";
import { orderByValues } from "../../../data/data";
import styleConstants from "../../../styleConstants";
import StackedColumnChart from "../../chart/StackedColumnChart";

const MethodMixOfUseVsCostChart = props => {
  const data = props.data;

  return (
    <div>
      <StackedColumnChart
        ref={props.innerRef}
        height={styleConstants.stackedBarHeight}
        categories={["User", "Cost"]}
        series={methods.map(method => ({
          name: method,
          color: styleConstants.categoryColors.methodColors[method],
          data: orderByValues(
            data.filter(datum => datum.method === method),
            ["User", "Cost"],
            "indicator"
          ).map(datum => datum.value)
        }))}
        reversedLegend={true}
        legendPosition={props.legendPosition}
        tooltipFormatter={props.tooltipFormatter}
      />
    </div>
  );
};

MethodMixOfUseVsCostChart.propTypes = {
  data: PropTypes.array.isRequired,
  legendPosition: PropTypes.string,
  tooltipFormatter: PropTypes.func
};

export default memo(
  React.forwardRef((props, ref) => (
    <MethodMixOfUseVsCostChart innerRef={ref} {...props} />
  ))
);
